import { render } from "./HeaderAction.vue?vue&type=template&id=1d8ffc7c&ts=true"
import script from "./HeaderAction.vue?vue&type=script&lang=ts"
export * from "./HeaderAction.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__